import React from 'react';

export function IconClose({ iconTitle, width, height }) {
  return (
    <svg
      className="icon-close"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={iconTitle}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-23.000000, -23.000000)" fill="#221F20">
          <polygon
            transform="translate(32.142136, 32.142136) rotate(45.000000) translate(-32.142136, -32.142136)"
            points="30.1421356 22.1421356 30.1421356 30.1421356 22.1421356 30.1421356 22.1421356 34.1421356
                30.1421356 34.1421356 30.1421356 42.1421356 34.1421356 42.1421356 34.1421356 34.1421356 42.1421356
                34.1421356 42.1421356 30.1421356 34.1421356 30.1421356 34.1421356 22.1421356"
          />
        </g>
      </g>
    </svg>
  );
}
